<template>
    <attribute-popover-base ref="base" :bindings="bindings" :disabled="disabled">
        <slot />
        <keen-team-member-picker 
            slot="controls" 
            v-model="internalValueProxy"
            :disabled="isSaving" 
        />
    </attribute-popover-base>
</template>

<script>
    import AttributePopover from './AttributePopover'
    import AttributePopoverBase from './AttributePopoverBase'

    export default {
        components: { AttributePopoverBase },
        mixins: [AttributePopover],
        props: {
            label: {
                type: String,
                default: 'Edit Attribute'
            }
        },
        computed: {
            internalValueProxy: {
                get() {
                    return this.internalValue ? this.internalValue : {}
                },
                set(value) {
                    this.internalValue = value
                }
            }
        }
    }
</script>